// import * as styles from './PinUpdateSuccessStyles';

import { css } from '@emotion/react';

import { getOtherIcons, ZeeFontBold, ZeeFontRegular } from 'src/styles/font';
import { OtherIconsSet } from 'src/utils/constants/IconsConstants';
// import css from "styled-jsx/css";

interface stringProps {
  z5Strings: {
    [key: string]: string;
  };
}

const successWrapper = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
`;
const success = css`
  text-align: center;
  display: block;
`;
const successtick = css`
  width: 86px;
  height: 86px;
  border: 2px solid #009c41;
  border-radius: 50%;
  line-height: 16px;
  text-align: center;
  color: #fff;
  background: #009c41;
  margin: 0 auto;
  ${getOtherIcons(OtherIconsSet.CHECK_MARK)};
  font-size: 75px;
  line-height: 85px;
`;
const title = css`
  margin: 25px;
  ${ZeeFontBold(18, 26)};
  text-align: center;
  color: #333333;
`;
const desc = css`
  margin: 0 25px 25px;
  @include ZeeFontBold(18px, 26px);
  ${ZeeFontRegular(14, 20)};
  text-align: center;
  color: #333333;
`;

const PinUpdateSuccess: React.FC<stringProps> = ({ z5Strings }) => {
  const { CreatePin_SuccessHeader_Text, CreatePin_SuccessSubHeader_Text } =
    z5Strings;
  return (
    <div css={successWrapper}>
      <div css={success}>
        <div css={successtick} />
      </div>
      <div css={title}>{CreatePin_SuccessHeader_Text}</div>
      <div css={desc}>{CreatePin_SuccessSubHeader_Text}</div>
    </div>
  );
};

export default PinUpdateSuccess;
